import React from 'react';
import styled from 'styled-components';
// import Icon from './Location__Icon';
import iconSVG from '../data/images/map.svg';

import { fadeOut, colors } from '../GlobalStyle';
import { calc4k } from '../utilities';

export default function Location({ text, fontSize, iconSize, showcase }) {
    return (
        <Container fontSize={fontSize}>
            {text && (
                <IconWrapper iconSize={iconSize}>
                    <IconContainer showcase={showcase}>
                        <Icon src={iconSVG} />
                    </IconContainer>
                </IconWrapper>
            )}
            <Text showcase>{text}</Text>
        </Container>
    );
}

const Container = styled.p`
    margin-top: 0.86vh;
    font-size: ${calc4k(46)};
    color: #ffffff;
    animation: ${fadeOut} 1200ms ease-in-out;
    transition: visibility 200ms ease-in-out;
`;

const IconWrapper = styled.span`
    display: inline-block;
    position: relative;
    margin-right: 1.1vw;
    width: ${calc4k(52)};
    height: ${calc4k(52)};
`;

const IconContainer = styled.span`
    display: block;
    position: absolute;
    top: ${p => (p.showcase ? 0.5 : 0.25)}vh;
    width: 100%;
    height: 100%;
`;

const Text = styled.span``;

const Icon = styled.img`
    height: ${calc4k(52)};
    width: auto;
`;
